import { render } from "./ProjectResultDetails.vue?vue&type=template&id=b4537712"
import script from "./ProjectResultDetails.vue?vue&type=script&lang=js"
export * from "./ProjectResultDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__